<mat-expansion-panel
  class="flotante-panel"
  [expanded]="expansionPanelExpanded"
  (expandedChange)="expansionPanelExpanded = $event"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">campaign</mat-icon>
      <span class="panel-title">Sirenas</span>
      <span class="counter-badge">
        {{ sirenasVisibles.length }}
        @if (sirenasVisibles.length !== (sirenas?.length ?? 0)) {
          / {{ sirenas?.length ?? 0 }}
        }
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- BUSCADOR POR DIRECCIÓN -->
  <div class="seccion top-bar">
    <div class="buscador-wrapper">
      <mat-icon class="search-icon material-symbols-outlined">
        location_on
      </mat-icon>
      <input
        type="text"
        class="buscador-input"
        placeholder="Buscar por dirección"
        [(ngModel)]="searchTerm"
        (input)="onBuscarDireccion()"
        (keyup.enter)="onBuscarDireccion()"
      />
      @if (searchTerm) {
        <button
          irxBotonIcono
          tamano="mini"
          class="clear-btn"
          (click)="limpiarBusqueda()"
          tooltip="Limpiar búsqueda"
        >
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </div>
  </div>

  <!-- CLIENTES -->
  @if (helper.tienePermiso('Administración - Ver clientes')) {
    <div class="seccion">
      <div class="seccion-titulo">Clientes</div>
      <app-cliente-selector
        [multiple]="true"
        [(ngModel)]="filtrosCliente"
        (ngModelChange)="onChangeFiltroClientes()"
        [filterModules]="['moduloSirenas']"
        margin="0"
      ></app-cliente-selector>
    </div>
  }

  <!-- CAPAS -->
  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <div class="poligonos-pills">
      <div class="pill-item">
        <irx-segmentado class="visibility-toggle-group" tamano="compacto">
          <irx-segmento
            (click)="onToggleCluster()"
            [activo]="clusterEnabled"
            [tooltip]="clusterEnabled ? 'Ocultar clusters' : 'Mostrar clusters'"
          >
            <mat-icon class="material-symbols-outlined">
              {{ clusterEnabled ? 'blur_on' : 'blur_off' }}
            </mat-icon>
          </irx-segmento>
        </irx-segmentado>
        <span class="pill-label">Mostrar</span>
      </div>
    </div>
  </div>

  <!-- ESTADOS -->
  <div class="seccion">
    <div class="seccion-titulo">
      <span>Estados</span>
      @if (filtrosEstado.length) {
        <button
          irxBotonIcono
          tamano="mini"
          class="btn-reset-inline"
          (click)="limpiarEstados()"
          tooltip="Mostrar todos los estados"
        >
          <mat-icon class="material-symbols-outlined">refresh</mat-icon>
        </button>
      }
    </div>
    <div class="estados-grid">
      @for (estado of estados; track estado.clave) {
        <button
          type="button"
          class="irx-chip irx-chip--multilinea capa-chip estado-chip"
          [attr.aria-pressed]="filtrosEstado.includes(estado.clave)"
          (click)="toggleEstado(estado.clave)"
        >
          <mat-icon class="material-symbols-outlined">
            {{ estado.icono }}
          </mat-icon>
          <span class="capa-label">{{ estado.label }}</span>
          <span class="capa-count">
            {{ contarSirenasPorEstadoTotal(estado.clave) }}
          </span>
        </button>
      }
    </div>
  </div>

  @if (hayFiltrosActivos) {
    <button
      irxBoton="secundario"
      type="button"
      class="limpiar-btn"
      (click)="limpiarFiltros()"
    >
      <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      Limpiar todo
    </button>
  }
</mat-expansion-panel>
